export const PageTitle = ({
  text,
  subtext = "",
  className = "",
  containerClassName = "",
}: {
  text: string;
  subtext?: string;
  className?: string;
  containerClassName?: string;
}) => {
  return (
    <div className={containerClassName}>
      <h1
        className={`text-xl md:text-2xl font-bold md:font-medium ${className}`}
      >
        {text}
      </h1>
      {subtext && (
        <p className="mt-1 md:mt-2 text-sm text-pry-dark-green-300/60">
          {subtext}
        </p>
      )}
    </div>
  );
};
